export default "__VITE_ASSET__gQXQR44z__"